/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: supportstrip.js (search)
 */
/**
 * Load support strip link lists
 */
//This javascript is obsolete. Please try to use Tc.Module.SupportStrip
$.namespace("SCS.supportstrip");

SCS.supportstrip.placeholder = '_keyword_';
SCS.supportstrip.NA = 'NA';//base64 url safe encoded

SCS.supportstrip.loadStrips = function() {	
	$(".scs-search-support-strip .links, .scs-support-strip-help .links").each(function() {
		var $this = $(this);
		var url = $this.data("url");
		var currentPagePath = $this.data("currentpagepath");
		var searchEnabled = $this.data("search-enabled");
		if (url.indexOf(SCS.supportstrip.placeholder)!==-1) {
			var keyword = escape($("#search").val());
			//$('#searchKeywordDefaultText') not exists in DOM !!!!
			var defaultKeyword = escape($("#searchKeywordDefaultText").data("value"));
			if (keyword == SCS.search.searchKeywordDefaultText || keyword == "" || keyword == defaultKeyword) {
				keyword = SCS.supportstrip.NA;//NA base64 url safe encoded
			}
			url = url.replace(SCS.supportstrip.placeholder, $.base64.encode(keyword).replace('=', '')); // URL Safe version of Base64
		}
		if (url != undefined) {
			$.get(url, {tagSrc:currentPagePath}, function(response, status, xhr) {
				$this.html(response);
				if (status != "success" && status != "notmodified") {
					$(this).hide();
				}
			});
		}
	});
};



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/supportstrip.js
// module id = 348
// module chunks = 0